/**
 * Choresmiths API
 * ## Admin API  - Common [HTTP error responses](https://lab4.itcraft.pl:8526/choresmiths-admin-api/swagger/result-codes-info)  - Common [validation errors messages](https://lab4.itcraft.pl:8526/choresmiths-admin-api/swagger/validation-messages-info)  - Common [business errors messages](https://lab4.itcraft.pl:8526/choresmiths-admin-api/swagger/business-errors-codes-info)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Error response with message that should be localized in client app.
 */
export interface ApiBusinessErrorDto {
	/**
	 * Reflects HTTP Response status code
	 */
	code: number;
	/**
	 * Message key
	 */
	resultKey: string;
	/**
	 * Message parameters
	 */
	resultParams?: Array<string>;
	/**
	 * Current timestamp
	 */
	timestamp: string;
}
